import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { AccessRequestFacade } from '../../../../Facades/access-request.facade';
import { LogoutService } from '../../../Shared/Services/logout.service';
import { MsgService } from '../../../Shared/Services/msg.service';

@Component({
  selector: 'app-request-access',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  templateUrl: './request-access.component.html',
  styleUrls: ['./request-access.component.scss'],
})
export class RequestAccessComponent {
  readonly facade = inject(AccessRequestFacade);
  private readonly _logoutService = inject(LogoutService);
  private readonly _msgService = inject(MsgService);

  readonly lastSentParams = computed<Record<string, string>>(() => ({
    date: this.formatDate(this.facade.lastRequestedAt()),
  }));

  readonly nextAllowedParams = computed<Record<string, string>>(() => ({
    date: this.formatDate(this.facade.nextAllowedAt()),
  }));

  async requestAccess(): Promise<void> {
    try {
      const response = await firstValueFrom(this.facade.send());
      this.facade.reload();
      this._msgService.showSnackBar(
        response.data.sent
          ? 'app.billing.licences.messages.access_requested'
          : 'app.billing.licences.messages.access_request_throttled',
        { type: response.data.sent ? 'success' : 'warning' },
      );
    } catch (error) {
      this.showFailure(error);
    }
  }

  logout(): void {
    this._logoutService.confirmLogout();
  }

  private formatDate(value: string | null): string {
    return value ? new Date(value).toLocaleString() : '';
  }

  private showFailure(error: unknown): void {
    const body = (error as { error?: { message?: string } })?.error;
    this._msgService.showSnackBar(body?.message ?? 'shared.general.errors.default', { type: 'error' });
  }
}
